export const formattedAmount = (amount: number): string => {
  if (isNaN(amount) || amount === null) {
    return '';
  }

  return new Intl.NumberFormat(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(amount);
};
